// extracted by mini-css-extract-plugin
export var container = "_db-0";
export var infoIcon = "_db-2";
export var internalLabel = "_db-3";
export var titleRowCol = "_db-1";